import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withRouter from './WithRouter';
import { orderDetails } from '../actions/order';

class OrderDetails extends React.Component {
    constructor() {
        super();
        this.state = {
          name: '',
          modal: false,
          orderdetails: [],
          order_id: '',
          errors: {}
        };
    }


    fetchApi(id) {
        this.props.orderDetails(id, this.props.history);
    }
    componentDidMount() {
        if(this.state.order_id !== '') {
            this.fetchApi(this.state.order_id);
        }
        // console.log(this.props)
    }

    componentDidUpdate(prevProps) {
        // if (prevState.orderdetails !== this.state.orderdetails) {
        //     console.log('Active order has changed.')
        //     this.setState({orderdetails: prevState.orderdetails.list});
        // }
        if ( this.props.orderdetails !== prevProps.orderdetails ) {
            // console.log('Active order has changed.')
            this.setState({orderdetails: this.props.orderdetails.list});
        }
        if ( this.props.orderdetailsactiveid !== prevProps.orderdetailsactiveid ) {
            // console.log('Active order has changed.')
            this.setState({order_id: this.props.orderdetailsactiveid.id});
            this.fetchApi(this.props.orderdetailsactiveid.id);

        }
    }

    render() {
        const { errors } = this.state;
        // console.log(this.props);
        // console.log(this.state.orderdetails);
        let order = this.state.orderdetails;
        return (
            <div>
            {order !== null &&
                <h2>
                {order.name}
                </h2>
            }
                
            </div>
        );
    }
}

// OrderDetails.propTypes = {
//     orderDetails: PropTypes.func.isRequired
// };


const mapStateToProps = state => ({
  orgcurrent: state.orgcurrent,
  orderdetails: state.orderdetails,
  orderdetailsactiveid: state.orderdetailsactiveid,
  errors: state.errors
});

export default connect(mapStateToProps,{orderDetails})(withRouter(OrderDetails))
